<template>
	<div id="event_window" class="create-task-container pb-4" @click="close_selection += 1">
		<div v-if="isEdit_local || isDuplication_local" class="top-line"></div>
		<div v-if="isEdit_local || isDuplication_local" class="pt-3 px-6 task-title">
			<div class="title-text">
				<span v-if="isEdit_local">Event</span>
				<span v-if="isDuplication_local">Add Event</span>
			</div>
			<div class="task-title">
				<Copy v-if="isEdit_local && !isDuplication_local" class="mr-3 step-item-text-hover" style="height: 16px; width: 16px" :color="'rgba(25, 42, 62, 0.7)'" @click="onCopyEvent()"/>
				<Delete v-if="isEdit_local && !isDuplication_local && !read_only" class="mt-1 step-item-text-hover" style="height: 20px; width: 20px" :color="`rgba(25, 42, 62, 0.7)`" @click="onDeleteEvent()"/>
				<v-icon @click.stop="onEditEventClose()">mdi-close</v-icon>
			</div>
		</div>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<template v-if="!loading">
			<v-row class="ma-0 px-6">
				<v-col class="pb-0 px-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 7">
					<v-row class="ma-0">
						<v-col class="px-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 6">
							<v-select
								class="type"
								v-model="event_type_select"
								:items="event_type_items"
								:menu-props="{ bottom: true, offsetY: true}"
								:background-color="error_type_flag ? 'error' : (event_type_select && !isEdit_local? '#609800' : '#82899B')"
								item-text="desc"
								item-value="id"
								:item-color="color"
								:error="error_type_flag"
								:color="color"
								:disabled="isEdit_local && read_only"
								placeholder="Select Event type..."
								autofocus
								outlined
								flat
								dense
								hide-details
								return-object
								@change="onSelected($event)"
							>
								<template v-slot:append>
									<v-icon v-if="isEdit_local" style="color: #FFFFFF"></v-icon>
									<v-icon v-if="!isEdit_local" style="color: #FFFFFF">mdi-chevron-down</v-icon>
								</template>
								<template v-slot:selection="{ item }">
									<span style="color: #FFFFFF">{{item.desc}}</span>
								</template>
							</v-select>
						</v-col>
					</v-row>
					<v-row class="ma-0">
						<v-col cols="12" class="px-0">
							<v-text-field
								v-model="event_name"
								:color="color"
								:error="error_name_flag"
								:disabled="isEdit_local && read_only"
								background-color="#FAFAFA"
								placeholder="Enter Event name here"
								outlined
								dense
								hide-details
								min-width="auto"
								@change="onNameChange()"
							>
							</v-text-field>
						</v-col>
					</v-row>
					<v-progress-linear v-if="type_loading" class="mx-2" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
					<v-row v-if="!type_loading" class="ma-0" justify="space-between" align="start">
						<v-col cols="9" class="px-0 py-0">
							<template v-if="event_wholeday">
								<span :class="isEdit_local && read_only ? 'item-text-disabled' : 'item-text'">Start date to End date</span>
								<DateMulti
									:suggestionText="`eg, 120322-130322 or 12/3/2022-13/3/2022`"
									:color="color"
									:background="`#FAFAFA`"
									:error="error_start_date_flag || error_end_date_flag"
									:disabled="isEdit_local && read_only"
									:dateStartInit="start_date"
									:dateEndInit="end_date"
									@dateRange="onDateRangeChange($event)"
								/>
							</template>							
							<template v-if="!event_wholeday">
								<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Date</span>
								<DatePicker
									style="width:100%"
									:isOutlined="true"
									:isIcon="true"
									:color="color"
									:suggestionText="`eg, 120322 or 12/3/2022`"
									:error="error_date_flag"
									:disabled="isEdit_local && read_only"
									:dateInit="start_date"
									@date="onDateChange($event)"
								/>
							</template>
						</v-col>
						<v-col cols="3" class="px-0">
							<div class="task-title" style="justify-content: flex-end">
								<v-checkbox
									v-model="event_wholeday"
									:color="color"
									:disabled="isEdit_local && read_only"
									dense
									hide-details
									@change="onAllDayChange($event)">
									<template v-slot:label>
										<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">All day</span>
									</template>
								</v-checkbox>
							</div>
						</v-col>
					</v-row>
					<div v-if="event_wholeday && !type_loading && event_date_optional" class="optional-text" style="float: right; line-height: 12px; margin-top: -8px;">optional</div>
					<v-row v-if="!event_wholeday && !type_loading" class="ma-0">
						<DateTime
							:color="color"
							:duration="`${event_duration}m`"
							:startTimeInit="time_start_init"
							:endTimeInit="time_end_init"
							:isOptional="event_date_optional"
							:startError="start_time_error"
							:errorStartFlag="error_start_time_flag"
							:endError="end_time_error"
							:errorEndFlag="error_end_time_flag"
							:disabled="isEdit_local && read_only"
							:styleLeft="`pl-0`"
							:styleRight="`pr-0`"
							@time_start="onTimeStartChange($event)"
							@time_end="onTimeEndChange($event)"
						/>
					</v-row>
					<v-row class="mt-0 mb-0 mx-0">
						<v-col class="px-0 pt-0" cols="12">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Time zone</span>
							<v-autocomplete
								v-model="timezone"
								:items="timezone_items"
								:color="color"
								:menu-props="{ bottom: true, offsetY: true}"
								:loading="timezone_loading"
								:disabled="isEdit_local && read_only"
								background-color="#FAFAFA"
								item-text="name"
								item-value="key"
								item-color="success"
								outlined
								dense
								hide-details
								return-object
								clearable
								@change="onTimezoneChange()"
							>
								<template v-slot:item="{item, on}">
									<v-list-item style="min-height: 32px">
										<v-row v-if="item.children !== 0" class="mt-2 mb-0">
											<v-col cols="12" class="py-0">
												<div class="step-item-text" style="font-weight: 500; color: rgba(25, 42, 62, 0.5)">{{ item.name }}</div>
											</v-col>
											<v-col cols="12" class="pt-1 pb-0">
												<v-divider></v-divider>
											</v-col>
										</v-row>
										<div v-if="item.children === 0" class="step-item-text step-item-text-hover" style="color: rgba(25, 42, 62, 1)" v-on="on">{{ item.name }}</div> 
									</v-list-item>
								</template>
							</v-autocomplete>
						</v-col>
					</v-row>
					<v-row class="ma-0">
						<v-col v-if="type_loading" class="px-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 6">
							<v-progress-linear v-if="type_loading" class="mx-2" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
						</v-col>
						<v-col v-if="event_is_due_date && !type_loading" class="px-0 pt-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 6">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Due date</span>
							<DatePicker
								:lableText="''"
								:isOutlined="true"
								:isIcon="true"
								:color="color"
								:error="error_due_flag"
								:suggestionText="''"
								:persistentHint="false"
								:disabled="isEdit_local && read_only"
								:dateInit="due_date"
								@date="onDueDateChange($event)"
							/>
						</v-col>
					</v-row>
					<v-row class="ma-0">
						<v-col v-if="type_loading" class="px-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 6">
							<v-progress-linear v-if="type_loading" class="mx-2" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
						</v-col>
						<v-col v-if="!type_loading" class="px-0 pt-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 6">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Recurrences</span>
							<v-select
								v-model="repeat_unit_select"
								:items="repeat_unit_items"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								:item-color="color"
								:color="color"
								:disabled="fix_repeatunit || (isEdit_local && read_only)"
								outlined
								dense
								hide-details
								return-object
								@change="onRepeatChange()"
							>
							</v-select>
						</v-col>
						<v-col v-if="!type_loading && repeat_unit_select !== repeat_unit_items[0] && repeat_unit_select !== repeat_unit_items[repeat_unit_items.length -1]" :class="$vuetify.breakpoint.xsOnly ? 'pa-0':'pr-0 py-0'" align-self="end" :cols="$vuetify.breakpoint.xsOnly ? 12 : 6">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Ending</span>
							<DatePicker
								:isOutlined="true"
								:isIcon="true"
								:persistentHint="false"
								:color="color"
								:suggestionText="''"
								:disabled="isEdit_local && read_only"
								:dateInit="ending_date"
								@date="onEndingDateChange($event)"
							/>
							<div class="ma-0 optional-text">optional</div>
						</v-col>
					</v-row>
					<v-row v-if="repeat_unit_select.value === (this.repeat_unit[this.repeat_unit.length - 1]).value" class="ma-0" align="center">
						<v-progress-linear v-if="type_loading" class="mx-2" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
						<v-col class="px-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 3">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Repeat day</span>
						</v-col>
						<v-col :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-0'" :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
							<v-text-field
								v-model="selected_repeat_digits"
								type="number"
								class="text-right"
								background-color="#FAFAFA"
								dense
								hide-details
								:color="color"
								:disabled="fix_repeatunit || (isEdit_local && read_only)"
								outlined
								min="0"
								step="1"
								oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
								@change="onRepeatDigitsChange()"
							/>
						</v-col>
						<v-col :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pr-0'" :cols="$vuetify.breakpoint.xsOnly ? 12 : 5">
							<v-select
								v-model="selected_repeat_frequency"
								:items="repeat_frequency_items"
								:menu-props="{ bottom: true, offsetY: true}"
								:color="color"
								:item-color="color"
								:disabled="fix_repeatunit || (isEdit_local && read_only)"
								background-color="#FAFAFA"
								outlined
								dense
								hide-details
								return-object
								@change="onRepeatFrequencyChange()"
							>
							</v-select>
						</v-col>
					</v-row>
					<v-row v-if="repeat_unit_select.value === (this.repeat_unit[this.repeat_unit.length - 1]).value" class="ma-0" align="center">
						<v-col class="pl-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 3">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Ending</span>
						</v-col>
						<v-col class="pa-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 9">
							<DatePicker
								:lableText="''"
								:isOutlined="true"
								:isIcon="true"
								:color="color"
								:suggestionText="''"
								:persistentHint="false"
								:disabled="isEdit_local && read_only"
								:dateInit="ending_date"
								@date="onEndingDateChange($event)"
							/>
						</v-col>
						<v-col class="pa-0" cols="12">
							<div class="ma-0 optional-text">optional</div>
						</v-col>
					</v-row>
					<v-row class="ma-0">
						<v-col v-if="alert_items.length > 0" class="pa-0" cols="12" >
							<template v-if="alert_items.length <= 3">
								<v-row class="ma-0" v-for="item of alert_items" :key="item.id" align="center">
									<v-col class="px-0" :class="$vuetify.breakpoint.xsOnly ? 'pt-2 pb-0':'py-2'" :cols="$vuetify.breakpoint.xsOnly ? 12 : 2">
										<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Notify me</span>
									</v-col>
									<v-col class="py-2" :class="$vuetify.breakpoint.xsOnly ? 'pl-0 pr-2':''" :cols="$vuetify.breakpoint.xsOnly ? 3 : 3">
										<v-text-field
											v-model="item.durantion"
											type="number"
											class="text-right"
											background-color="#FAFAFA"
											dense
											hide-details
											:color="color"
											:disabled="isEdit_local && read_only"
											outlined
											min="0"
											step="1"
											oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
										/>
									</v-col>
									<v-col class="px-0 py-2" :cols="$vuetify.breakpoint.xsOnly ? 6 : 4">
										<v-select
											v-model="item.frequency"
											:items="alert_frequency"
											:menu-props="{ bottom: true, offsetY: true}"
											:color="color"
											:item-color="color"
											:disabled="isEdit_local && read_only"
											background-color="#FAFAFA"
											outlined
											dense
											hide-details
										>
										</v-select>
									</v-col>
									<v-col class="py-2" :class="$vuetify.breakpoint.xsOnly ? 'pl-1 pr-0':''" :cols="$vuetify.breakpoint.xsOnly ? 2 : 2">
										<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">before</span>
									</v-col>
									<v-col class="px-0 py-2" :cols="$vuetify.breakpoint.xsOnly ? 1 : 1">
										<v-btn :disabled="isEdit_local && read_only" icon color="rgba(25, 42, 62, 0.5)" @click="onRemoveNotification(item.id)">
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</template>
							<template v-if="alert_items.length > 3">
								<v-virtual-scroll
									:items="alert_items"
									height="170"
									item-height="56"
								>
									<template v-slot:default="{ item }">
										<v-row class="ma-0" align="center">
											<v-col class="px-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 2">
												<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Notify me</span>
											</v-col>
											<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3">
												<v-text-field
													v-model="item.durantion"
													type="number"
													class="text-right"
													background-color="#FAFAFA"
													dense
													hide-details
													:color="color"
													:disabled="isEdit_local && read_only"
													outlined
													min="0"
													step="1"
													oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
												/>
											</v-col>
											<v-col class="px-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
												<v-select
													v-model="item.frequency"
													:items="alert_frequency"
													:menu-props="{ bottom: true, offsetY: true}"
													:color="color"
													:item-color="color"
													:disabled="isEdit_local && read_only"
													background-color="#FAFAFA"
													outlined
													dense
													hide-details
												>
												</v-select>
											</v-col>
											<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 2">
												<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">before</span>
											</v-col>
											<v-col class="px-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 1">
												<v-btn :disabled="isEdit_local && read_only" icon color="rgba(25, 42, 62, 0.5)" @click="onRemoveNotification(item.id)">
													<v-icon>mdi-close</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</template>
								</v-virtual-scroll>
							</template>
						</v-col>
						<v-col class="pa-0" cols="12">
							<v-btn :disabled="isEdit_local && read_only" class="text-capitalize px-0" text color="#82899B" @click="onAddNotification()">Add Notification...</v-btn>
						</v-col>
					</v-row>
					<v-row v-if="links === mandatory_job" class="ma-0">
						<v-col class="px-0 py-0" cols="12">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Job</span>
							<v-autocomplete
								v-model="job_select"
								:items="job_items"
								:loading="job_loading"
								:search-input.sync="job_search"
								:color="color"
								:error="error_job_flag || (links === mandatory_job && !job_select)"
								:disabled="isEdit_local && read_only"
								prepend-inner-icon="mdi-magnify"
								append-icon=""
								background-color="#FAFAFA"
								item-text="display_name"
								item-value="id"
								item-color="success"
								item-disabled="disabled"
								placeholder="Type to search job names or numbers"
								auto-select-first
								outlined
								dense
								hide-no-data
								return-object
								hide-details
								clearable
								@change="onJobSelected($event)"
							>
							</v-autocomplete>
						</v-col>
					</v-row>
					<v-row v-if="links !== no_related" class="ma-0">
						<v-col :class="links === optional ? 'px-0 pb-0':'px-0'" cols="12">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Address Book</span>
							<v-autocomplete
								v-model="address_select"
								:items="address_items"
								:loading="address_loading"
								:search-input.sync="address_search"
								:color="color"
								:error="error_addressbook_flag || ((links === mandatory || links === mandatory_job) && !address_select)"
								:disabled="isEdit_local && read_only"
								prepend-inner-icon="mdi-magnify"
								append-icon=""
								background-color="#FAFAFA"
								item-text="display_name"
								item-value="id"
								item-color="success"
								item-disabled="disabled"
								placeholder="Type to search companies, suppliers, freelancers etc."
								outlined
								dense
								hide-no-data
								return-object
								hide-details
								clearable
								@change="onAddressSelected($event)"
							>
							</v-autocomplete>
							<div v-if="links === optional" class="optional-text">optional</div>
						</v-col>
					</v-row>
					<v-row v-if="is_contact_needed && is_business" class="ma-0">
						<v-col class="pa-0" cols="12">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Contact</span>
							<v-autocomplete
								v-model="contact_select"
								:items="contact_items"
								:loading="contact_loading"
								:search-input.sync="contact_search"
								:color="color"
								:disabled="isEdit_local && read_only"
								prepend-inner-icon="mdi-magnify"
								append-icon=""
								background-color="#FAFAFA"
								item-text="display_name"
								item-value="id"
								item-color="success"
								item-disabled="disabled"
								placeholder="Type to search contact names"
								no-data-text=""
								auto-select-first
								outlined
								dense
								return-object
								hide-details
								clearable
								@change="onContactSelected($event)"
							>
							</v-autocomplete>
							<div class="optional-text" style="float: right; line-height: 12px; margin-top: 4px;">optional</div>
						</v-col>
					</v-row>
					<v-row v-if="!description_loading" class="ma-0">
						<v-col class="px-0 pb-0" cols="12">
							<span :class="isEdit_local && read_only ? 'item-text-disabled':'item-text'">Event Description</span>
							<RichText v-model="content" :toolbar="toolbar" :plugins="plugins" :height="250" :disabled="isEdit_local && read_only" />
						</v-col>
					</v-row>
				</v-col>
				<v-col class="pb-0" :class="!$vuetify.breakpoint.xsOnly ? 'pr-0':'px-0'"  :cols="$vuetify.breakpoint.xsOnly ? 12 : 5">
					<v-row class="ma-0" style="height: 100%">
						<v-divider v-if="!$vuetify.breakpoint.xsOnly" vertical color="#D9D9D9"/>
						<div class="column-container" :style="$vuetify.breakpoint.xsOnly ? 'width: 100%':'width: 99%'">
							<div v-if="can_invitemultiple" :class="[!$vuetify.breakpoint.xsOnly ? 'px-2':'', isEdit_local && read_only ? 'item-text-disabled':'item-text']">Invitees</div>
							<div v-if="can_invitemultiple" class="column-container" :class="!$vuetify.breakpoint.xsOnly ? 'px-2':''">
								<InviteesTreeSelection
									:color="color"
									:bgColor="'#FAFAFA'"
									:selected="select_invitees"
									:organiser="organiser"
									:address="address_select"
									:closeSelection="close_selection"
									@assign-selected="onInviteeSelected($event)"
								/>
							</div>
							<div v-if="can_invitemultiple" class="item-text ml-2 mt-3">Select invitees below to email:</div>
							<div v-if="can_invitemultiple" class="ml-2 mb-2">
								<v-checkbox
									v-model="email"
									:color="color"
									dense
									hide-details
									:disabled="!can_invitemultiple || (isEdit_local && read_only)"
									@change="onAllEmailChange()">
									<template v-slot:label>
										<span class="item-text" :style="!can_invitemultiple? 'opacity: 0.5':''">Select all</span>
									</template>
								</v-checkbox>
							</div>
							<div v-if="organiser" class="task-title pl-2 mb-3">
								<div>
									<v-checkbox
										class="px-0 pt-0 mt-0"
										v-model="organiser.employee.send_email"
										:color="color"
										:disabled="!can_invitemultiple || (isEdit_local && read_only)"
										dense
										hide-details
										@change="onEmailChange()">
										<template v-slot:label>
											<div class="task-top over-background" style="justify-content: flex-start">
												<div class="mr-1">
													<v-user-avatar
														size="24"
														class="text-caption text-decoration-none"
														:code="formatName(organiser.employee.display_name)"
														:image="organiser.employee.image ? organiser.employee.image : `/api/addressbook/${organiser.employee.id}/image.png`"
													/>
												</div>
												<div class="column-container">
													<div class="item-text over-text" style="width: 148px;">
														<span style="color: #192A3E">{{ formatName(organiser.employee.display_name) }}</span>
														<span style="color: rgba(25, 42, 62, 0.7); font-size: 12px;">&nbsp;&nbsp;Organiser</span>
													</div>
													<div class="item-text over-text" style="color: rgba(25, 42, 62, 0.7); font-size: 12px; width: 148px;">{{ organiser.employee.email }}</div>
												</div>
											</div>
										</template>
									</v-checkbox>
								</div>
								<div>
									<v-btn :disabled="isEdit_local && read_only" icon x-small max-width="36" min-width="36" min-height="36" max-height="36" color="rgba(25, 42, 62, 0.5)" @click.stop="onEditOrganiser(organiser.employee.send_email)">
										<v-icon>mdi-pencil</v-icon>
									</v-btn>
								</div>
							</div>
							<div :style="`height: ${selected_invitees_height + 8}px`">
								<v-virtual-scroll
									:items="inviteesFilter"
									:height="$vuetify.breakpoint.xsOnly ? 100:`${selected_invitees_height}px`"
									item-height="48"
								>
									<template v-slot:default="{ item }">
										<div class="task-title pl-2">
											<div v-if="item.employee">
												<v-checkbox
													class="mt-0 pt-0"
													v-model="item.employee.send_email"
													:color="color"
													:disabled="isEdit_local && read_only"
													dense
													hide-details
													@change="onEmailChange()">
													<template v-slot:label>
														<div class="task-top over-background" style="justify-content: flex-start">
															<div class="mr-1">
																<v-user-avatar
																	size="24"
																	class="text-caption text-decoration-none"
																	:code="formatName(item.employee.display_name)"
																	:image="`/api/addressbook/${item.employee.id}/image.png`"
																/>
															</div>
															<div class="column-container">
																<div class="item-text over-text" style="color: #192A3E">{{ formatName(item.employee.display_name) }}</div>
																<div v-if="item.employee.email.length !== 0" class="item-text over-text" style="color: rgba(25, 42, 62, 0.7); font-size: 12px; width: 148px;">{{ item.employee.email }}</div>
															</div>
														</div>
													</template>
												</v-checkbox>
											</div>
											<div>
												<v-btn :disabled="isEdit_local && read_only" icon color="rgba(25, 42, 62, 0.5)" @click.stop="onRemoveInvitee(item.id)">
													<v-icon>mdi-close</v-icon>
												</v-btn>
											</div>
										</div>
									</template>
								</v-virtual-scroll>
							</div>
						</div>
					</v-row>
				</v-col>
			</v-row>
			<v-row class="ma-0 pl-5 pr-9" justify="space-between">
				<v-checkbox
					v-model="mark_complete"
					label="Mark complete"
					color="info"
					dense
					hide-details
					:disabled="isEdit_local && read_only"
					@change="onMarkCompleteChange()">
				</v-checkbox>
				<v-row v-if="read_only && isDuplication_local" :class="$vuetify.breakpoint.xsOnly ? 'mt-3 mb-0 mx-0':'ma-0'" :justify="$vuetify.breakpoint.xsOnly ? 'center':'end'">
					<v-btn class="text-capitalize mr-2" outlined color="#82899B" @click="$emit('close')">Cancel</v-btn>
					<v-btn class="text-capitalize white--text" elevation="0" color="#00AAFD" :disabled="!isNextActive" @click="onSave()">
						<span>Create Event</span>
					</v-btn>
				</v-row>
				<v-row v-if="!read_only" :class="$vuetify.breakpoint.xsOnly ? 'mt-3 mb-0 mx-0':'ma-0'" :justify="$vuetify.breakpoint.xsOnly ? 'center':'end'">
					<v-btn class="text-capitalize mr-2" outlined color="#82899B" @click="$emit('close')">Cancel</v-btn>
					<v-btn class="text-capitalize white--text" elevation="0" color="#00AAFD" :disabled="!isNextActive" @click="onSave()">
						<span v-if="isEdit_local">Save Event</span>
						<span v-else>Create Event</span>
					</v-btn>
				</v-row>
			</v-row>
		</template>
		<OrganiserDialog
			v-if="organiser_visible" 
			:visible="organiser_visible"
			:color="color"
			:sendEmail="organiser_send_email"
			:contact="address_select"
			@cancel="organiser_visible = false"
			@submit="onOrganiserChange($event)"
		/>
		<RecurringComfirmDialog
			v-if="recurring_comfirm_visible" 
			:visible="recurring_comfirm_visible"
			:color="color"
			@cancel="recurring_comfirm_visible = false"
			@submit="onRepeatModeComfirm($event)"
		/>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="`You are about to delete this Event.`" 
			:content="`This action cannot be undone. Are you sure?`"
			:isMode="repeat_event"
			:ok="'Yes, delete'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="delete_visible = false"
			@ok="onDelete($event)"
		/>
	</div>
</template>

<script>
import InviteesTreeSelection from "@/views/events/invitees_tree_selection.vue"
import DateMulti from "@/components/date/date_multi.vue";
import DatePicker from "@/components/date/date_picker.vue";
import DateTime from "@/components/date/date_time.vue";
import RichText from '@/views/rtf/RichText';
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import OrganiserDialog from "@/views/events/organiser_dialog.vue";
import RecurringComfirmDialog from "@/views/events/recurring_comfirm_dialog.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";
import Copy from '@/components/icons/copy';
import Delete from '@/components/icons/delete_outline';

import { validTime } from "@/common/validTime.js";

import config from "@/config.js";
import moment from 'moment-timezone';

/**
 * https://github.com/antoniolucasnobar/html-to-rtf-browser
 * copy whole src into project(removing testing file)
 **/
// import Rtf from "@/views/rtf/html_to_rtf/rtf/rtf.class.js";
// const htmlToRtf = new Rtf();


/**
 * https://github.com/tbluemel/rtf.js
 * convert simple table, change base on master branch
 */
// RTFJS.loggingEnabled(false);

const ALLEMPLOYEES = 2;
const CLIENT = 3;
const FREELANCER = 4;

/** 0-invited, 1-accepted, 2-rejected */
const Invited_Code = 0;
const Accepted_Code = 1;
const Rejected_Code = 2;

const Repeat_Unit = [
	{
		text: 'Doesn’t repeat', 
		value: 0
	},
	{
		text: 'Daily', 
		value: 1
	},
	{
		text: 'Weekly', 
		value: 5
	},
	{
		text: 'Monthly', 
		value: 3
	},
	{
		text: 'Yearly', 
		value: 4
	},
	{
		text: 'Custom recurrence...', 
		value: 6
	}
];

/** etrepeatunit => 0 - no repeat, 1 - day, 2 - Weekday(not support it now), 3 - Monthly, 4 - Yearly, 5 - Weekly */
const Repeat_Frequency = [
	// {
	// 	text: 'None', 
	// 	value: 0
	// },
	{
		text: 'Days', 
		value: 1
	},
	// {
	// 	text: 'Weekdays',
	// 	value: 2
	// },
	{
		text: 'Weeks', 
		value: 5
	},
	{
		text: 'Months', 
		value: 3
	},
	{
		text: 'Years', 
		value: 4
	}
];
const Mode = 1; /** 1 - this event only */
const Weekday = 2;

const Alert_Frequency = ['Minute(s)', 'Hour(s)', 'Day(s)', 'Week(s)'];
const Minutes_Day = 60 * 24;

/** 0-tentative, 1-busy, 2 - leave */
const Plan_Type_Leave = 2;

const DescriptionLimit = 60;

/** if event_duration = 0, will set defaul duration(30mins) */
const Event_Duration_Default = 30;

const JOr = 'JOr';
/** If selected the user can only modify events he/she owns (has created) */
const EVOwn = 'EVOwn';

/**
 * 0=Other
 * 1=client
 * 2=Suppliers
 * 3=Employees
 * 6=Banks
 * 7=(Non)-performing artists
 * 8=Talent agencies
 * 9=Credit card suppliers
 * 10=Superannuation suppliers(Super fund)
 * 12=Freelancers
 * 14=Prospect
 * 15=Self billing talent
 * 16=Contacts
 * 17=Media suppliers
 * 18=Freelancer agencies
 */
const Address_Types = [1,2,9,10,12,14,17,18];

/** 
 *  0 - not display job and adddress
 *  1 - display job and adddress, but no required
 *  2 - display adddress, required
 *  3 - display job and adddress, required
 */
const No_Related = 0;
const Optional = 1;
const Mandatory = 2;
const Mandatory_Job = 3;

const Plugins = 'advlist lists table image link';
const Toolbar = ['bold italic underline strikethrough backcolor forecolor | indent outdent', 'align numlist bullist | link image inserttable'];

export default {
	name: 'NewEvent',
	props: {
		color: {
			type: String,
			default: ''
		},
		isEdit: {
			type: Boolean,
			default: false
		},
		isDuplication: {
			type: Boolean,
			default: false
		},
		editEventItem: {
			type: Object,
			default: null,
		},
		adbid: {
			type: Number,
			default: 0
		},
		joid: {
			type: Number,
			default: 0
		},
		coid: {
			type: Number,
			default: 0
		},
		startTime: {
			type: String,
			default: ''
		}
	},
	data() {
		this.repeat_unit = Repeat_Unit;
		this.alert_frequency = Alert_Frequency;
		this.toolbar = Toolbar;
		this.plugins = Plugins;

		this.no_related = No_Related;
		this.optional = Optional;
		this.mandatory = Mandatory;
		this.mandatory_job = Mandatory_Job;

		this.invited_code = Invited_Code;
		this.accepted_code = Accepted_Code;
		this.rejected_code = Rejected_Code;

		return {
			loading: false,
			type_loading: false,
			job_loading: false,
			address_loading: false,
			contact_loading: false,
			invitees_loading: false,
			timezone_loading: false,
			description_loading: false,

			error_msg: '',
			close_selection: 0,
			read_only: false,
			isDuplication_local: this.isDuplication,
			isEdit_local: this.isEdit,
			selected_invitees_height: 0,

			event_name: '',
			event_type_select: null,
			event_type_items: [],

			event_wholeday: true,
			event_duration: 0,
			event_date_optional: false,
			event_is_due_date: true,

			start_date: '',
			end_date: '',
			event_start_date: null,
			event_end_date: null,
			origin_event_start_date: null,
			origin_event_end_date: null,

			event_date: null,
			event_start_time: null,
			event_end_time: null,
			time_start_init: '',
			time_end_init: '',
			origin_event_date: null,
			origin_event_start_time: null,
			origin_event_end_time: null,

			timezone_items: [],
			timezone: null,
			user_timezone: '',

			due_date: '',
			event_due_date: null,
			
			repeat_unit_select: Repeat_Unit[0],
			repeat_unit_items: Repeat_Unit,

			selected_repeat_digits: 0,
			selected_repeat_frequency: Repeat_Frequency[0],
			repeat_frequency_items: Repeat_Frequency,
			fix_repeatunit: false,

			ending_date: '',
			event_ending_date: null,

			alert_items: [],
			init_id: 0,

			links: 0,
			is_contact_needed: false,
			job_select: null,
			job_items: [],
			job_search: null,
			job_invalid_status_ids: [],

			address_select: null,
			address_items: [],
			address_search: null,
			is_business: true,

			contact_select: null,
			contact_items: [],
			contact_search: null,
			
			content: '',
			mark_complete: false,

			can_invitemultiple: true,
			email: !this.isEdit && !this.isDuplication ? true : false,
			select_invitees: [],
			invitees_items: [],
			invitees_search: null,
			organiser_visible: false,
			organiser_send_email: true,
			organiser: null,
			existed_invitees: [],
			
			error_name_flag: false,
			error_type_flag: false,
			error_start_date_flag: false,
			error_end_date_flag: false,
			error_date_flag: false,
			error_start_time_flag: false,
			error_end_time_flag: false,
			error_due_flag: false,
			error_job_flag: false,
			error_addressbook_flag: false,
			button_click_flag: false,


			start_time_error: false,
			end_time_error: false,

			recurring_comfirm_visible: false,

			visible_notice: false,
			notice_text: [],
			tid: null,

			delete_visible: false,
			repeat_event: false,
		}
	},
	components: {
		InviteesTreeSelection,
		DateMulti,
		DatePicker,
		RichText,
		DialogNotice,
		OrganiserDialog,
		RecurringComfirmDialog,
		DeleteConfirmDialog,
		Copy,
		Delete,
		DateTime
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		this.description_loading = true;
		this.loading = this.isEdit_local || this.isDuplication_local;

		await this.getTimezone();
		await this.getUserTimezone();
		await this.getEventTypes();
		this.tid = setTimeout(this.initDescription(), 1000);

		if (!this.isEdit_local && !this.isDuplication_local) {
			await this.getCurrentUser();
		}
		
		await this.getJobStatusIds();

		if (this.isEdit_local || this.isDuplication_local) {
			await this.getEvent(this.editEventItem);
		}

		if (this.adbid !== 0) {
			this.getAddressById(this.adbid);
		}

		if (this.joid !== 0) {
			this.getJobById(this.joid);
		}

		if (this.coid !== 0) {
			this.getContactById(this.coid);
		}

		if (this.startTime.length !== 0) {
			this.event_wholeday = false;
			this.event_duration = Event_Duration_Default;

			this.start_date = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');
			this.end_date = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');

			this.event_date = this.start_date;
			this.event_end_date = this.end_date;

			this.event_start_time = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('h:mm a');
			this.event_end_time = moment(this.startTime, 'YYYY-MM-DD HH:mm').add(Event_Duration_Default, 'm').format('h:mm a');

			this.time_start_init = this.event_start_time ? this.event_start_time : '';
			this.time_end_init = this.event_end_time ? this.event_end_time : '';
		}
	},
	mounted() {
		this.selected_invitees_height = this.getWindowHeight();
	},
	computed: {
		userAddressBook() {
			let user_tmp = null;
			
			if (this.$store.state.user && this.$store.state.user.addressbook) {
				user_tmp = this.$store.state.user.addressbook;
			}		

			return user_tmp;
		},
		isNextActive() {
			let next_active_tmp = false;

			if (this.event_name.length !== 0 && this.event_type_select && this.timezone) {
				let valid_date = false;
				if (this.event_wholeday) {
					valid_date = this.event_start_date && this.event_end_date && this.event_start_date <= this.event_end_date;
				} else {
					const time1 = moment(this.event_start_time, 'HH:mm a');
					const time2 = moment(this.event_end_time, 'HH:mm a');
					valid_date = this.event_date && this.event_start_time && this.event_end_time && (time2.diff(time1, 'minutes') > 0);
				}
				
				const date_valid = this.event_date_optional ? true : valid_date;
				const due_valid = this.event_is_due_date ?  this.event_due_date : true;
				const job_valid = this.links === Mandatory_Job ? this.job_select : true;
				const address_valid = this.links === Mandatory_Job || this.links === Mandatory ? this.address_select : true;
				if (date_valid && due_valid && job_valid && address_valid) {
					next_active_tmp = true;
				}
			}

			return next_active_tmp;
		},
		completedJobPrivilege() {
			let isCompletedJobTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(JOr)) {
				isCompletedJobTmp = true;
			}
			return isCompletedJobTmp
		},
		amendOwnEventsPrivilege() {
			let isAmendOwnEvents = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(EVOwn)) {
				isAmendOwnEvents = true;
			}
			return isAmendOwnEvents;
		},
		inviteesFilter() {
			let invitees_list = [];

			if (this.select_invitees.length !== 0) {
				const obj_tmp = {};
				this.select_invitees.forEach(d => {
					if (!obj_tmp[d.employee.id]) {
						invitees_list.push(d);
						obj_tmp[d.employee.id] = true;
					}
				});
			}

			return invitees_list;
		}
	},
	watch: {
		job_search(val) {
			val && (this.job_select ?  val !== this.job_select.display_name : true) && this.jobQuery(val);
		},
		address_search(val) {
			val && (this.address_select ?  val !== this.address_select.display_name : true) && this.addressQuery(val);
		},
		contact_search(val) {
			val && (this.contact_select ?  val !== this.contact_select.display_name : true) && this.contactQuery(val);
		},
		invitees_search(val) {
			val && this.inviteesQuery(val);
		}
	},
	methods: {
		getWindowHeight() {
			const elem = document.getElementById("event_window");
			const height_rect = elem.getBoundingClientRect().height;
			const height_init = this.$vuetify.breakpoint.width <= 1024 ? this.$vuetify.breakpoint.width - 48 : 800;

			const height = (height_rect === 0 || height_rect < 100) ? height_init - 40 : height_rect;

			return Math.floor(height);
		},
		initDescription() {
			this.description_loading = false;
		},
		async getUserTimezone() {
			const url = '/api/user/me/timezone';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_timezone = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getTimezone() {
			this.timezone_loading = true;

			const url = '/api/support/timezones';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const timezone_group = {};

						const data_filter = data.filter(d => {
							const time_zone_key = d.value.toUpperCase();
							return !time_zone_key.includes(config.time_zone_keys[0]) && !time_zone_key.includes(config.time_zone_keys[1]);
						});
						data_filter.forEach(timezone => {
							const group_key = (timezone.value.split('/'))[0];
							const group_key_arr = Object.keys(timezone_group);

							if (group_key_arr.includes(group_key)) {
								const arr = timezone_group[`${group_key}`];

								const child = {
									key: timezone.value,
									name: `${(timezone.description.split(' '))[0]} (GMT${(timezone.description.split(' '))[1]})`,
									is_default: timezone.is_default,
									children: 0
								}

								timezone_group[`${group_key}`] = [...arr, child];
							} else {
								const child = {
									key: timezone.value,
									name: `${(timezone.description.split(' '))[0]} (GMT${(timezone.description.split(' '))[1]})`,
									is_default: timezone.is_default,
									children: 0
								}
								timezone_group[`${group_key}`] = [child];
							}
						});

						let timezone_list = [];
						for (const [key, value] of Object.entries(timezone_group)) {
							const node = {
								key: `parent_${key}`,
								name: key,
								is_default: false,
								children: value.length
							}
							timezone_list= [...timezone_list, node, ...value];
						}
						this.timezone_items = timezone_list;

						if (!this.isEdit_local && !this.isDuplication_local) {
							const default_timezone_arr = timezone_list.filter(timezone => { return timezone.is_default === true});
							this.timezone = default_timezone_arr.length !== 0 ? default_timezone_arr[0] : null;
						}
					} else {
						this.error_msg = reason;
						this.timezone_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.timezone_loading = false;
				})
				.finally(() => {
					this.timezone_loading = false;
				})
		},
		async getEventTypes() {
			const url = '/api/config/eventtype';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const event_type_items_tmp = data.filter(d => { return d.plan_type !== Plan_Type_Leave });
						this.event_type_items = event_type_items_tmp;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getCurrentUser() {
			if (this.userAddressBook) {
				const organiser_obj = {
					id: 0,
					accepted: Accepted_Code,
					contact: null,
					employee: {
						id: this.userAddressBook.id,
						code: this.userAddressBook.code,
						display_name: this.userAddressBook.display_name,
						email: this.userAddressBook.email,
						send_email: true,
						image: this.userAddressBook.image,
						uri: this.userAddressBook.uri
					}
				};

				this.organiser = organiser_obj;
			} else {
				const url =  '/api/user/me';
				
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const { status, data, reason } = val.data;

						if (status == "OK") {
							const organiser_obj = {
								id: 0,
								accepted: Accepted_Code,
								contact: null,
								employee: {
									id: data.addressbook.id,
									code: data.addressbook.code,
									display_name: data.addressbook.display_name,
									email: data.userAddressBook.email,
									send_email: true,
									image: data.addressbook.image,
									uri: data.addressbook.uri
								}
							};
				
							this.organiser = organiser_obj;
						} else {
							this.error_msg = reason;
						}
					})
					.catch((e) => {
						this.error_msg = e.message;
					});
			}
		},
		async getJobStatusIds() {
			const url = '/api/jobs/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const statuses_arr = data.substatusses;
						const job_invalid_statusses = statuses_arr.filter(s => { return !config.job_status_group_nomal.includes(s.group) });
						this.job_invalid_status_ids = job_invalid_statusses.map(s => { return s.id });
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getEvent(event) {
			this.loading = true;

			const url = `/api/events/${event.id}?iteration=${event.iteration}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.loading = false;

						if (this.userAddressBook.id !== data.organiser.id && this.amendOwnEventsPrivilege) {
							this.read_only = true;
						}

						this.event_name = data.description;
						this.event_date_optional = data.event_type.date_optional === 1 ? true : false;
						this.event_wholeday = data.all_day;

						const timezone_key = data.time_zone && data.time_zone.length !== 0 ? data.time_zone : this.user_timezone;
						this.timezone = (this.timezone_items.filter(timezone => { return timezone.key === timezone_key }))[0];

						const event_type = {
							id: data.event_type.id,
							desc: data.event_type.desc,
							plan_type: data.event_type.plan_type,
						};
						this.event_type_select = event_type;

						if (data.all_day) {
							this.start_date = moment(data.start_date).format('YYYY-MM-DD');
							this.end_date = moment(data.end_date).format('YYYY-MM-DD');

							this.event_start_date = moment(data.start_date).format('YYYY-MM-DD');
							this.event_end_date = moment(data.end_date).format('YYYY-MM-DD');

							this.origin_event_start_date = this.event_start_date;
							this.origin_event_end_date = this.event_end_date;
							this.event_duration = Event_Duration_Default;

						} else {
							this.start_date = moment(data.start_date).format('YYYY-MM-DD');
							this.event_date = moment(data.start_date).format('YYYY-MM-DD');
							this.origin_event_date = this.event_date;

							this.event_start_time = moment(data.start_datetime, 'YYYYMMDD HH:mm').format('h:mm a');
							this.event_end_time = moment(data.end_datetime, 'YYYYMMDD HH:mm').format('h:mm a');

							this.time_start_init = this.event_start_time ? this.event_start_time : '';
							this.time_end_init = this.event_end_time ? this.event_end_time : '';

							this.origin_event_start_time = this.event_start_time;
							this.origin_event_end_time = this.event_end_time;

							const start_tmp = moment(data.start_date);
							const end_tmp = moment(data.end_date);
							const diff = end_tmp.diff(start_tmp, 'm');
							this.event_duration = diff === 0 ? Event_Duration_Default : diff;
						}

						this.event_is_due_date = data.event_type.has_due === 1 ? true : false;
						this.due_date = data.due_date ? data.due_date : '';
						this.event_due_date = data.due_date;

						this.fix_repeatunit = data.event_type.fix_repeatunit;
						
						if (data.repeat_unit === Repeat_Unit[0].value || data.repeat_unit === Weekday) {
							this.repeat_unit_select = Repeat_Unit[0];
						} else {
							const repeat_unit_from_type = (Repeat_Unit.filter(u => { return u.value === data.repeat_unit }))[0];
							this.repeat_unit_select = data.repeat_value === 1 ? repeat_unit_from_type : Repeat_Unit[Repeat_Unit.length - 1];

							this.selected_repeat_digits = data.repeat_value;
							this.selected_repeat_frequency = (Repeat_Frequency.filter(r => { return r.value === data.repeat_unit }))[0];
						}


						this.ending_date = data.repeat_end ? data.repeat_end : '';
						this.event_ending_date = data.repeat_end;

						this.alert_items = data.alerts && data.alerts.length > 0 ? this.setAlertItems(data.alerts) : [];
						
						this.links = data.event_type.links;
						this.is_contact_needed = data.event_type.contact_needed;

						if (data.job) {
							data.job['display_name'] = `${data.job.code} - ${data.job.display_name}`
							this.job_select = data.job;
							this.job_items.push(this.job_select);
						}

						if (data.client) {
							const address_tmp = data.client;
							address_tmp['name'] = data.client.display_name;
							this.address_select = address_tmp;
							this.address_items.push(this.address_select);

							this.is_business = data.client.is_company;
						}

						if (data.contact) {
							this.contact_select = data.contact;
							this.contact_items.push(this.contact_select);
						}
						
						this.content = data.notes_fmt;						
				
						this.mark_complete = data.is_ticked === 1 ? true : false;

						const invitees_tmp = [];
						data.invitees.forEach(invite => {
							const name = this.formatName(invite.contact ? invite.contact.display_name : invite.employee.display_name);
							const description = name.length > DescriptionLimit
								? name.slice(0, DescriptionLimit) + '...'
								: name;
								

							let prefix_tag = ALLEMPLOYEES;
							if (invite.employee.is_employee && invite.employee.is_feelancer) {
								prefix_tag = ALLEMPLOYEES;
							} else if (invite.employee.is_feelancer) {
								prefix_tag = FREELANCER;
							} 

							const invite_obj = {
								id: `${invite.contact ? CLIENT :  prefix_tag}_${invite.contact ? invite.contact.id :invite.employee.id}`,
								name: description,
								type: invite.contact ? CLIENT : prefix_tag,
								accepted: invite.accepted,
								contact: null,
								freelancer: prefix_tag === FREELANCER ? true : false,
								employee: {
									id: invite.contact ? invite.contact.id: invite.employee.id,
									contact_id: invite.contact ? invite.contact.id : null,
									code: invite.contact ? '' : invite.employee.code,
									display_name: invite.contact ? invite.contact.display_name : invite.employee.display_name,
									email: invite.contact ?  invite.contact.email : invite.employee.email,
									send_email: false
								},
								image: `/api/addressbook/${invite.contact ? invite.contact.id :invite.employee.id}/image.png`,
								uri: `/api/addressbook/${invite.contact ? invite.contact.id :invite.employee.id}`
							};
							invitees_tmp.push(invite_obj);
						});
						
						this.existed_invitees = data.invitees.map(i => { return {id: `${i.contact ? CLIENT :ALLEMPLOYEES}_${i.employee.id}`, invite_id: i.id} });

						const organiser_arr = invitees_tmp.filter(invite => { return invite.employee.id === data.organiser.id });
						const organiser_orignal = {
							id: 0,
							accepted: Accepted_Code,
							contact: null,
							freelancer: false,
							employee: {
								id: data.organiser.id,
								contact_id: null,
								code: data.organiser.code,
								display_name: data.organiser.display_name,
								email: data.organiser.email,
								send_email: false
							}
						};

						this.organiser = organiser_arr.length === 0 ? organiser_orignal: organiser_arr[0];
						this.select_invitees = invitees_tmp.filter(invite => { return invite.employee.id !== data.organiser.id });
						this.can_invitemultiple = data.event_type.invite_multiple;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		getAddressById(id) {
			this.loading = true;
			
			const url = `/api/addressbook/${id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						this.address_items.push(data);

						this.address_select = JSON.parse(JSON.stringify(data));
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false
				});

		},
		getJobById(id) {
			this.loading = true;
			
			const url = `/api/jobs/${id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						const name = this.formatName(data.description);
						const description = name.length > DescriptionLimit
							? name.slice(0, DescriptionLimit) + '...'
							: name;

						let is_disabled = false;
						if (this.completedJobPrivilege) {
							is_disabled = this.job_invalid_status_ids.includes(data.status.id) ? true : false;
						}	

						const obj = {
							id: data.id,
							display_name: `${data.code} - ${description}`,
							acc_dir: data.acc_dir,
							acc_exec: data.acc_exec,
							job_type: data.job_type,
							currency_id: data.currency.id,
							currency: data.currency,
							disabled: is_disabled
						};
						
						this.job_items.push(obj);
						this.job_select = obj;
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false
				});

		},
		getContactById(id) {
			this.loading = true;

			const url = `/api/addressbook/contacts/${id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						this.contact_items.push(data);
						this.contact_select = JSON.parse(JSON.stringify(data));
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false
				});
		},
		jobQuery(key) {
			this.job_loading = true;
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const code_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return code_lowercase.includes(key_lowercase);
						});
						
						const desc_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return !code_lowercase.includes(key_lowercase);
						});

						const data_filter = [...code_data, ...desc_data];
						
						this.job_items = data_filter.map(d => {
							const description = d.display_name.length > DescriptionLimit
								? d.display_name.slice(0, DescriptionLimit) + '...'
								: d.display_name;
							
							let is_disabled = false;
							if (this.completedJobPrivilege) {
								is_disabled = this.job_invalid_status_ids.includes(d.status.id) ? true : false;
							}

							const obj = {
								id: d.id,
								display_name: description,
								acc_dir: d.acc_dir,
								acc_exec: d.acc_exec,
								job_type: d.job_type,
								currency_id: d.currency.id,
								currency: d.currency,
								disabled: is_disabled,
								client: d.client,
								contact: d.contact
							};

							return obj;
						});

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.job_loading = false
				});
		},
		addressQuery(key) {
			this.address_loading = true;

			const params = [];
			params.push("name=" + encodeURIComponent(key));
			params.push("abook_types=" + Address_Types);

			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						data.forEach(d => { d['display_name'] = this.formatName(d.display_name)});
						this.address_items = data;
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.address_loading = false
				});
		},
		contactQuery(key) {
			this.contact_loading = true;
			
			const params = [];
			params.push("name=" + encodeURIComponent(key));
			if (this.address_select) {
				params.push("abook_ids=" + this.address_select.id);
			}
			if (this.job_select) {
				params.push("job_ids=" + this.job_select.id);
			}

			let url = `/api/addressbook/contacts`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						data.forEach(d => { d['display_name'] = this.formatName(d.display_name)});
						this.contact_items = data;

						if (this.contact_items.length === 1) {
							this.contact_select = this.contact_items[0];
						}
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.contact_loading = false;
				});
		},
		inviteesQuery(key) {
			this.invitees_loading = true;

			const params = [];
			params.push("name=" + encodeURIComponent(key));
			params.push("allow_all=" + true);
			params.push("find_employee=" + true);
			params.push("find_freelancer=" + true);

			let url = "/api/addressbook/email";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						this.invitees_items = data.map(d => {
							const name = this.formatName(d.name);
							const description = name.length > DescriptionLimit
								? name.slice(0, DescriptionLimit) + '...'
								: name;


							const invite_obj = {
								id: 0,
								accepted: Invited_Code,
								contact: null,
								employee: {
									id:  d.contact_id ? d.contact_id : d.abook_id,
									contact_id: d.contact_id ? d.contact_id : null,
									code: d.code,
									display_name: description,
									email: d.email,
									send_email: true
								},
								image: `${d.uri}/image.png`,
								uri: d.uri
							};

							return invite_obj;
						});
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.invitees_loading = false
				});
		},
		onCopyEvent() {
			this.isEdit_local = false;
			this.isDuplication_local = true;
		},
		onDeleteEvent() {
			let repeat_event = true;

			if (this.editEventItem.repeat_unit === 0) {
				repeat_event = false;
			} else {
				let end_date_by_unit = '';
				
				// daily
				if (this.editEventItem.repeat_unit === 1) {
					const days_tmp = this.editEventItem.repeat_value - 1;
					end_date_by_unit = moment(this.editEventItem.end_date).add(days_tmp, 'd').format('YYYY-MM-DD');
				}

				// weekly
				if (this.editEventItem.repeat_unit === 5) {
					const days_tmp = 7 * this.editEventItem.repeat_value - 1;
					end_date_by_unit = moment(this.editEventItem.end_date).add(days_tmp, 'd').format('YYYY-MM-DD');
				}

				// monthly
				if (this.editEventItem.repeat_unit === 3) {
					const days_tmp = this.editEventItem.repeat_value;
					end_date_by_unit = moment(this.editEventItem.end_date).add(days_tmp, 'M').format('YYYY-MM-DD');
				}
				
				if (this.editEventItem.repeat_end && this.editEventItem.repeat_end.length !== 0 && (this.editEventItem.repeat_end === moment(this.editEventItem.end_date).format('YYYY-MM-DD') || this.editEventItem.repeat_end <= end_date_by_unit)) {
					repeat_event = false;
				}
			}

			this.repeat_event = repeat_event;
			this.delete_visible = true;
		},
		onDelete(mode) {
			const params = [];
			params.push('iteration=' + this.editEventItem.iteration);

			if (this.repeat_event) {
				params.push('repeat_mode=' + mode);
			}

			let url = `/api/events/${this.editEventItem.id}`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.delete_visible = false;
						const title = this.editEventItem.description;

						this.notice_text.push(`Event ‘(${title})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		onEditEventClose() {
			this.$emit('close');
		},
		onSelected(event_type) {
			this.type_loading = true;

			const url = `/api/config/eventtype/${event_type.id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.event_name = data.comm;
						this.event_wholeday = data.is_wholeday;
						this.event_duration = Number(data.duration) === 0 ? Event_Duration_Default : Number(data.duration);

						if (!data.is_wholeday && this.startTime.length !== 0) {
							this.event_end_time = moment(this.event_start_time, 'h:mm a').add(this.event_duration, 'm').format('h:mm a');
							this.time_end_init = this.event_end_time ? this.event_end_time : '';
						}

						this.event_date_optional = data.date_optional === 1 ? true : false;
						this.event_is_due_date = data.has_due === 1 ? true: false;

						if (data.repeat_unit === Repeat_Unit[0].value || data.repeat_unit === Weekday) {
							this.repeat_unit_select = Repeat_Unit[0];
						} else {
							const repeat_unit_from_type = (Repeat_Unit.filter(u => { return u.value === data.repeat_unit }))[0];
							this.repeat_unit_select = data.repeat_value === 1 ? repeat_unit_from_type : Repeat_Unit[Repeat_Unit.length - 1];

							this.selected_repeat_digits = data.repeat_value;
							this.selected_repeat_frequency = (Repeat_Frequency.filter(r => { return r.value === data.repeat_unit }))[0];
						}

						this.alert_items = data.alert < 0 ? [] : this.getAlertItems(data.alert);
						this.links = data.links;
						this.is_contact_needed = data.is_contact_needed;
						this.mark_complete = data.pre_tick;
						this.can_invitemultiple = data.can_invitemultiple;
						if (this.can_invitemultiple) {
							this.email = true;
							this.organiser.employee.send_email = true;
						} else {
							this.email = false;
							this.organiser.employee.send_email = false;
							this.select_invitees = [];
						}
						this.fix_repeatunit = data.fix_repeatunit;

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.type_loading = false;
				});

			this._checkErrorFlag('onSelected');
		},
		onNameChange() {
			this._checkErrorFlag('onNameChange');
		},
		onAllDayChange(is_all_day) {
			/** is_all_day: false => part time, true => whole day  */
			if (is_all_day) {
				if (this.event_date) {
					this.start_date = this.event_date;
					this.end_date = this.event_date;

					this.event_start_date = this.event_date;
					this.event_end_date = this.event_date;
				}
			} else {
				if (this.event_start_date && this.event_end_date) {
					this.event_date = this.event_start_date;
				}
			}

			this._checkErrorFlag('onNameChange');
		},
		onDateRangeChange(date_arr) {
			this.error_msg = '';

			if (date_arr.length === 0) {
				this.start_date = '';
				this.end_date = '';
			}

			if (date_arr.length === 2) {
				this.event_start_date = date_arr[0];
				this.event_end_date = date_arr[1];

				this.start_date = date_arr[0];
				this.end_date = date_arr[1];
			}

			if (this.isEdit_local) {
				this.criticalInfoChange(this.event_start_date, this.origin_event_start_date);
				this.criticalInfoChange(this.event_end_date, this.origin_event_end_date);
			}

			this._checkErrorFlag('onEndDateChange');
		},
		onDateChange(date) {
			this.event_date = date;

			if (this.isEdit_local) {
				this.criticalInfoChange(this.event_date, this.origin_event_date);
			}

			this.start_date = date;
			this.end_date = date;

			this._checkErrorFlag('onDateChange');
		},
		onTimeStartChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.event_start_time = time;

			if (this.isEdit_local) {
				this.criticalInfoChange(this.event_start_time, this.origin_event_start_time);
			}

			this._time_error_check('start');
			this._checkErrorFlag('onStartTimeChange');
		},
		onTimeEndChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.event_end_time = time;

			if (this.isEdit_local) {
				this.criticalInfoChange(this.event_end_time, this.origin_event_end_time);
			}

			this._time_error_check('end');
			this._checkErrorFlag('onEndTimeChange');
		},
		_time_error_check(type) {
			const time_start = this.event_start_time ? this.event_start_time: '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.event_end_time ? this.event_end_time : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
				const time1 = moment(time_start_tmp, 'HH:mma');
				const time2 = moment(time_end_tmp, 'HH:mma');
				const budget = time2.diff(time1, 'minutes');

				if (budget < 0) {
					if (type === 'start') {
						this.start_time_error = true;
					}

					if (type === 'end') {
						this.end_time_error = true;
					}
				} 
			}
		},
		onTimezoneChange() {
			this._checkErrorFlag('all');
		},
		onDueDateChange(due_date) {
			this.event_due_date = due_date;
			this._checkErrorFlag('all');
		},
		onRepeatChange() {
			this._checkErrorFlag('all');
		},
		onRepeatDigitsChange() {
			this._checkErrorFlag('all');
		},
		onRepeatFrequencyChange() {
			this._checkErrorFlag('all');
		},
		onEndingDateChange(end_date) {
			this.event_ending_date = end_date;
			this._checkErrorFlag('all');
		},
		onAddNotification() {
			this.init_id += 1;

			const alert_item = {
				id: `0_${this.init_id}`,
				durantion: 0,
				frequency: Alert_Frequency[0]
			};

			this.alert_items.push(alert_item);

			this._checkErrorFlag('all');
		},
		onJobSelected(job) {
			this._checkErrorFlag('onJobSelected');
			this.contact_select = null;
			this.contact_items = [];

			if (job) {
				const ad_obj = {
					id: job.client.id,
					display_name: job.client.name,
					code: job.client.code,
					is_company: job.client.is_company
				};

				this.address_items.push(ad_obj);
				this.address_select = ad_obj;
				this.is_business = job.client.is_company;

				if (this.is_contact_needed && this.is_business) {
					if (job.contact) {
						const contact = job.contact;
						contact['display_name'] = this.formatName(job.contact.name);

						this.contact_items.push(contact);
						this.contact_select = contact;
					}
				}
			}
		},
		onAddressSelected(adddress) {
			this._checkErrorFlag('onAddressSelected');

			if (adddress === null) {
				this.is_business = true;
				this.contact_select = null;
				this.contact_items = [];
			}

			if (adddress !== null) {
				this.is_business = adddress.is_company;
				this.contact_select = null;
				this.contact_items = [];
			}
		},
		onContactSelected() {
			this._checkErrorFlag('onJobSelected');
		},
		onInviteeSelected(invitees) {
			this.select_invitees = invitees;
			this._checkErrorFlag('onJobSelected');
		},
		clearInviteesItems() {
			this.invitees_items = [];
		},
		onMarkCompleteChange() {
			this._checkErrorFlag('onJobSelected');
		},
		onAllEmailChange() {
			if (this.email) {
				this.organiser.employee.send_email = true;

				this.select_invitees.forEach(invite => {
					invite.employee.send_email = true;
				});

			} else {
				this.organiser.employee.send_email = false;

				this.select_invitees.forEach(invite => {
					invite.employee.send_email = false;
				});
			}
		},
		onEmailChange() {
			this._checkErrorFlag('onJobSelected');

			const is_all_selected = this.select_invitees.length === 0 ? true : this.select_invitees.every(invite => { return invite.employee.send_email === true });
			const is_organiser_selected = this.organiser.employee.send_email;

			if (is_all_selected && is_organiser_selected) {
				this.email = true;
			} else {
				this.email = false;
			}
		},
		onOrganiserChange(organiser) {
			this.organiser = organiser;
			this.organiser_visible = false;
			this.organiser_send_email = true;
		},
		onRemoveNotification(id) {
			this.alert_items = this.alert_items.filter(a => { return a.id !== id });
			this._checkErrorFlag('all');
		},
		onRemoveInvitee(id) {
			const e_id = Number((id.split('_'))[1]);
			this.select_invitees = this.select_invitees.filter(invitee => { return invitee.employee.id !== e_id });

			this._checkErrorFlag('onJobSelected');
		},
		onEditOrganiser(send_email) {
			this.organiser_visible = true;
			this.organiser_send_email = send_email;
			this._checkErrorFlag('onJobSelected');
		},
		onRepeatModeComfirm(mode) {
			const repeat_mode_obj = {
				iteration: this.editEventItem.iteration,
				repeat_mode: mode
			};
			const params = this.getParams(repeat_mode_obj);
			this._updateEvent(this.editEventItem.id, params);
			
			this.recurring_comfirm_visible = false;
		},
		async onSave() {
			if (this.button_click_flag) return;

			this.button_click_flag = true;

			this._checkErrorFlag('onJobSelected');

			if (this.isEdit_local) {
				let repeat_event = true;
				if (this.editEventItem.repeat_unit === 0) {
					repeat_event = false;
				} else {
					let end_date_by_unit = '';
				
					// daily
					if (this.editEventItem.repeat_unit === 1) {
						const days_tmp = this.editEventItem.repeat_value - 1;
						end_date_by_unit = moment(this.editEventItem.end_date).add(days_tmp, 'd').format('YYYY-MM-DD');
					}

					// weekly
					if (this.editEventItem.repeat_unit === 5) {
						const days_tmp = 7 * this.editEventItem.repeat_value - 1;
						end_date_by_unit = moment(this.editEventItem.end_date).add(days_tmp, 'd').format('YYYY-MM-DD');
					}

					// monthly
					if (this.editEventItem.repeat_unit === 3) {
						const days_tmp = this.editEventItem.repeat_value;
						end_date_by_unit = moment(this.editEventItem.end_date).add(days_tmp, 'M').format('YYYY-MM-DD');
					}
				
					if (this.editEventItem.repeat_end && this.editEventItem.repeat_end.length !== 0 && (this.editEventItem.repeat_end === moment(this.editEventItem.end_date).format('YYYY-MM-DD') || this.editEventItem.repeat_end <= end_date_by_unit)) {
						repeat_event = false;
					}
				}

				if (repeat_event) {
					this.recurring_comfirm_visible = true;
				} else {
					const repeat_mode_obj = {
						iteration: this.editEventItem.iteration,
						repeat_mode: Mode
					};
					const params = this.getParams(repeat_mode_obj);
					this._updateEvent(this.editEventItem.id, params);
				}
				
			} else {
				const params = this.getParams();
				this._creaetEvent(params);
			}
		},
		formatName(name) {
			let display_name = '';

			if (name && name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		getAlertItems(value) {
			let result = {
				num: 0,
				unit: this.alert_frequency[0]
			};

			if (value === 0) {
				result.num = 0;
				result.unit = this.alert_frequency[0];
			}

			if (value < 60 && value > 0) {
				result.num = value;
				result.unit = this.alert_frequency[0];
			}

			if (value >= 60 && value < Minutes_Day) {
				if (Number.isInteger(value / 60)) {
					const hours = Math.floor(value / 60);
					result.num = hours;
					result.unit = this.alert_frequency[1];
				} else {
					result.num = value;
					result.unit = this.alert_frequency[0];
				}
			}

			if (value >= Minutes_Day) {
				if (Number.isInteger(value / Minutes_Day)) {
					const days = Math.floor(value / Minutes_Day);
					result.num = days;
					result.unit = this.alert_frequency[2];
				} else {
					result.num = value;
					result.unit = this.alert_frequency[0];
				}
			}

			if (result.unit === this.alert_frequency[2]) {
				if (result.num >= 7 && Number.isInteger(result.num / 7)) {
					const weeks = Math.floor(result.num / 7);
					result.num = weeks;
					result.unit = this.alert_frequency[3];
				}
			}

			this.init_id += 1;
			const alert_item = {
				id: this.init_id,
				durantion: result.num,
				frequency: result.unit
			};

			return [alert_item];
		},
		setAlertItems(alerts) {
			let alert_arr = [];

			alerts.forEach(alert => {
				const alert_tmp = this.getAlertItems(alert.alert_mins);
				(alert_tmp[0])['id'] = alert.id;
				alert_arr.push(alert_tmp[0]);
			});

			return alert_arr;
		},
		criticalInfoChange(new_value, old_value) {
			if (new_value !== old_value && this.can_invitemultiple) {
				this.email = true;
				this.organiser.employee.send_email = true;
				this.select_invitees.forEach(invite => {
					invite.employee.send_email = true;
				});
			}
		},
		getParams(repeat_mode_obj=null) {
			const params = {};

			params['event_type_id'] = this.event_type_select.id;
			params['description'] = this.event_name;
			params['all_day'] = this.event_wholeday;
			params['timezone'] = this.timezone.key;
			
			/** timezone conversion */
			const start_date_tmp = this.event_wholeday ?
				moment(`${this.event_start_date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
				: moment(`${this.event_date} ${this.event_start_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');
			
			const end_date_tmp = this.event_wholeday ?
				moment(`${this.event_end_date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
				: moment(`${this.event_date} ${this.event_end_time}`, 'YYYY-MM-DD hh:mm a').format('YYYY-MM-DD HH:mm:ss');

			moment.tz.setDefault(this.timezone.key);
			const timezone_start_date = moment(start_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
			const timezone_end_date = moment(end_date_tmp, 'YYYY-MM-DD HH:mm:ss').tz(this.user_timezone).format();
			moment.tz.setDefault(this.user_timezone);

			const start_date = moment(timezone_start_date).utc().format('YYYY-MM-DD HH:mm:ss Z');
			const end_date = moment(timezone_end_date).utc().format('YYYY-MM-DD HH:mm:ss Z');

			params['start_date'] = start_date;
			params['end_date'] = end_date;

			if (!this.event_wholeday) {
				const start_time = moment(this.event_start_time, 'hh:mm a');
				const end_time = moment(this.event_end_time, 'hh:mm a');
				const duration = end_time.diff(start_time, 'minutes');
				params['duration'] = duration;
			}
			if (this.links === Mandatory || this.links === Mandatory_Job || this.address_select) {
				params['abook_id'] = this.address_select.id;
			}
			if ((this.is_contact_needed || this.coid !== 0) && this.contact_select) {
				params['contact_id'] = this.contact_select.id;
			}
			if (this.links === Mandatory_Job || this.job_select) {
				params['job_id'] = this.job_select.id;
			}

			params['employee_id'] = this.organiser.employee.id;
			params['plan_type'] = this.event_type_select.plan_type;
			
			/** plain format */
			params['notes'] =  this.content.length !== 0 ? this.htmlToPlain(this.content) : '';
			/** html format */
			params['notes_fmt'] = this.content;
			/** rtf format, not ues now */
			// params['notes_fmt'] = this.content.length !== 0 ? htmlToRtf.convertHtmlToRtf(this.content): '';
			
			params['is_ticked'] = this.mark_complete ? 1 : 0;

			if (this.repeat_unit_select.value === Repeat_Unit[0].value) {
				params['repeat_unit'] = this.repeat_unit_select.value;
				params['repeat_value'] = 0;
			} else if (this.repeat_unit_select.value === Repeat_Unit[Repeat_Unit.length - 1].value) {
				const repeat_value_tmp = typeof(this.selected_repeat_digits) === 'string' ? Number(this.selected_repeat_digits) : this.selected_repeat_digits;
				if (repeat_value_tmp === 0) {
					params['repeat_unit'] = Repeat_Unit[0].value
					params['repeat_value'] = 0;
				} else {
					params['repeat_unit'] = this.selected_repeat_frequency.value;
					params['repeat_value'] = repeat_value_tmp;
				}
			} else {
				params['repeat_unit'] = this.repeat_unit_select.value;
				params['repeat_value'] = 1;
			}

			if (this.event_ending_date) {
				params['repeat_end'] = this.event_ending_date;				
			}

			if (this.event_is_due_date) {
				params['event_due'] = moment(this.event_due_date).utc().format('YYYY-MM-DD HH:mm:ss Z');
			}

			if (this.alert_items.length !== 0 ) {
				const alert_list = [];

				this.alert_items.forEach(alert => { 
					const alert_obj = {
						id: typeof(alert.id) === 'string' && alert.id.includes('_') ? 0 : alert.id,
						alert_mins: this._getMinutes(alert.durantion, alert.frequency)
					};
					alert_list.push(alert_obj)
				});
				
				params['alerts'] = alert_list;
			} else {
				params['alerts'] = [];
			}

			if (this.select_invitees.length === 0) {
				const id_arr = this.existed_invitees.filter(i => { return i.id === this.organiser.id})
				const invite_id = this.organiser && id_arr.length !== 0 ? id_arr[0].invite_id : 0;

				const invitee_obj = {
					id: this.isDuplication_local ? 0 : invite_id,
					accepted: Accepted_Code,
					is_deleted: false,
					pay_processed: false,
					send_email: this.organiser.employee.send_email,
					email_id: this.organiser.employee.email,
					is_organiser: true
				};

				if (this.organiser.employee.contact_id) {
					invitee_obj['contact_id'] = this.organiser.employee.contact_id;
				} else {
					invitee_obj['employee_id'] = this.organiser.employee.id;
				}

				params['invitees'] = [invitee_obj];
			} else {
				const invitee_list = [];
				
				const id_arr = this.existed_invitees.filter(i => { return i.id === this.organiser.id})
				const invite_id = this.organiser && id_arr.length !== 0 ? id_arr[0].invite_id : 0;

				const invitee_obj = {
					id: this.isDuplication_local ? 0 : invite_id,
					accepted: Accepted_Code,
					is_deleted: false,
					pay_processed: false,
					send_email: this.organiser.employee.send_email,
					email_id: this.organiser.employee.email,
					is_organiser: true
				};

				if (this.organiser.employee.contact_id) {
					invitee_obj['contact_id'] = this.organiser.employee.contact_id;
				} else {
					invitee_obj['employee_id'] = this.organiser.employee.id;
				}
				
				invitee_list.push(invitee_obj);

				const unique = [];
				const obj_tmp = {};
				this.select_invitees.forEach(d => {
					if (!obj_tmp[d.employee.id]) {
						unique.push(d);
						obj_tmp[d.employee.id] = true;
					}
				});

				unique.forEach(invitee => {
					const id_arr = this.existed_invitees.filter(i => { return i.id === invitee.id})
					const invite_id = id_arr.length !== 0 ? id_arr[0].invite_id : 0;

					const invitee_obj = {
						id: this.isDuplication_local ? 0 : invite_id,
						accepted: invitee.accepted,
						is_deleted: false,
						pay_processed: false,
						send_email: invitee.employee.send_email,
						email_id: invitee.employee.email,
						is_organiser: false
					}

					if (invitee.employee.contact_id) {
						invitee_obj['contact_id'] = invitee.employee.contact_id;
					} else {
						invitee_obj['employee_id'] = invitee.employee.id;
					}

					invitee_list.push(invitee_obj);
				});

				params['invitees'] = invitee_list;
			}

			if (repeat_mode_obj) {
				params['iteration'] = repeat_mode_obj.iteration;
				params['repeat_mode'] = repeat_mode_obj.repeat_mode;
			}

			return params;			
		},
		_creaetEvent(params) {
			const url = '/api/events';

			axios
				.post(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Event has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		_updateEvent(id, params) {
			const url = `/api/events/${id}`;

			axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.notice_text.push('Event has been updated successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		_checkErrorFlag(key) {
			this.error_name_flag = false;
			this.error_type_flag = false;
			this.error_start_date_flag = false;
			this.error_end_date_flag = false;
			this.error_date_flag = false;
			this.error_start_time_flag = false;
			this.error_end_time_flag = false;
			this.error_due_flag = false;
			this.error_job_flag = false;
			this.error_addressbook_flag = false;

			if (key === 'onSelected') {
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
			}

			if (key === 'onNameChange' ) {
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
			}

			if (key === 'onStartDateChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
				}
			}

			if (key === 'onEndDateChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
					if (!this.event_end_date) {
						this.error_end_date_flag = true;
					}
				}
			}

			if (key === 'onDateChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (!this.event_wholeday) {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
				}
			}

			if (key === 'onStartTimeChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (!this.event_wholeday) {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
				}
			}

			if (key === 'onEndTimeChange') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}
				if (!this.event_wholeday) {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
					if (!this.event_end_time) {
						this.error_end_time_flag = true;
					}
				}
			}

			if (key === 'all') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}

				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
					if (!this.event_end_date) {
						this.error_end_date_flag = true;
					}
					
				} else {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
					if (!this.event_end_time) {
						this.error_end_time_flag = true;
					}
				}

				if (this.event_is_due_date && !this.event_due_date) {
					this.error_due_flag = true;
				}
			}

			if (key === 'onJobSelected') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}

				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
					if (!this.event_end_date) {
						this.error_end_date_flag = true;
					}
					
				} else {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
					if (!this.event_end_time) {
						this.error_end_time_flag = true;
					}
				}

				if (this.event_is_due_date && !this.event_due_date) {
					this.error_due_flag = true;
				}

				if (this.links === Mandatory_Job && !this.job_select) {
					this.error_job_flag = true;
				}
			}

			if (key === 'onAddressSelected') {
				if (this.event_name.length === 0) {
					this.error_name_flag = true;
				}
				if (!this.event_type_select) {
					this.error_type_flag = true;
				}

				if (this.event_wholeday) {
					if (!this.event_start_date) {
						this.error_start_date_flag = true;
					}
					if (!this.event_end_date) {
						this.error_end_date_flag = true;
					}
					
				} else {
					if (!this.event_date) {
						this.error_date_flag = true;
					}
					if (!this.event_start_time) {
						this.error_start_time_flag = true;
					}
					if (!this.event_end_time) {
						this.error_end_time_flag = true;
					}
				}

				if (this.event_is_due_date && !this.event_due_date) {
					this.error_due_flag = true;
				}

				if (this.links === Mandatory_Job && !this.job_select) {
					this.error_job_flag = true;
				}

				if ((this.links === Mandatory_Job || this.links === Mandatory) && !this.address_select) {
					this.error_addressbook_flag = true;
				}
			}
		},
		_getMinutes(value, unit) {
			let minutes = 0;

			if (unit === Alert_Frequency[0]) {
				minutes = value;
			}

			if (unit === Alert_Frequency[1]) {
				minutes = value * 60;
			}

			if (unit === Alert_Frequency[2]) {
				minutes = value * Minutes_Day;
			}

			if (unit === Alert_Frequency[3]) {
				minutes = value * Minutes_Day * 7;
			}

			return Number(minutes);
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
			this.$emit('close');
		},
		stringToArrayBuffer(string) {
			const buffer = new ArrayBuffer(string.length);
			const bufferView = new Uint8Array(buffer);
			for (let i = 0; i < string.length; i++) {
				bufferView[i] = string.charCodeAt(i);
			}
			return buffer;
		},
		htmlToPlain(html_str) {
			const dom_tmp = document.createElement('div');
			dom_tmp.innerHTML = html_str;
			return dom_tmp.textContent || dom_tmp.innerText || '';
		}
	}
}
</script>

<style lang="scss" scoped>
.create-task-container {
  background: #FFFFFF;
  border-radius: 4px;
  max-width: 100%;
}
.column-container {
	display: flex;
	flex-flow: column nowrap;
	align-content: flex-start;
}
.row-container {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
}
.top-line {
  width: 100%;
  height: 4px;
  background: #81CC00;
  border-radius: 4px 4px 0px 0px;
}
.task-top {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.title-text {
	font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #81CC00;
}
.item-text {
	font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
	opacity: 0.87;
}
.item-text-disabled {
	font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
	opacity: 0.5;
}
.over-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.over-background {
	&:hover {
		background-color: #FAFAFA;
		border-radius: 4px;
	}
}

.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	color: #F45252;
}
.step-item-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #37495F;
}
.step-item-text-hover {
	&:hover {
		cursor: pointer;
	}
}

::v-deep {
	.type.v-input input::placeholder {
		color: #FFFFFF;
	}
}
</style>